/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

/**
 * Dictionary resource endpoints.
 */
@Injectable({
  providedIn: 'root',
})
export class DictionaryService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /**
   * Path part for operation getDictionaryValues
   */
  static readonly GetDictionaryValuesPath = '/dict';

  /**
   * Get dictionary values by types.
   *
   * Finds and returns the saved dictionary values
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDictionaryValues()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDictionaryValues$Response(
    params: {
      types: Array<string>;
    },
    context?: HttpContext
  ): Observable<
    StrictHttpResponse<{
      [key: string]: Array<string>;
    }>
  > {
    const rb = new RequestBuilder(
      this.rootUrl,
      DictionaryService.GetDictionaryValuesPath,
      'get'
    );
    if (params) {
      rb.query('types', params.types, {});
    }

    return this.http
      .request(
        rb.build({
          responseType: 'json',
          accept: 'application/json',
          context: context,
        })
      )
      .pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<{
            [key: string]: Array<string>;
          }>;
        })
      );
  }

  /**
   * Get dictionary values by types.
   *
   * Finds and returns the saved dictionary values
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getDictionaryValues$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDictionaryValues(
    params: {
      types: Array<string>;
    },
    context?: HttpContext
  ): Observable<{
    [key: string]: Array<string>;
  }> {
    return this.getDictionaryValues$Response(params, context).pipe(
      map(
        (
          r: StrictHttpResponse<{
            [key: string]: Array<string>;
          }>
        ) =>
          r.body as {
            [key: string]: Array<string>;
          }
      )
    );
  }
}
